<template>
    <UDropdownMenu :items="currencyDropdownItems" class="currency-selector">
        <UButton
            :label="currency"
            color="neutral"
            variant="ghost"
            size="sm"
            trailing-icon="i-lucide-chevron-down"
            class="min-w-[56px] font-medium"
            tabindex="-1"
            @mousedown.prevent
        />
    </UDropdownMenu>
</template>

<script setup lang="ts">
import { useCatalogStore } from '@/store/catalog'
import { useSettingsStore } from '@/store/settings'
const catalog = useCatalogStore()
const settings = useSettingsStore()
const priceFields = [
  'MSRPCAD', 'MSRPUSD', 'MSRPEUR', 'MSRPGBP', 'MSRPCHF'
]
const availableCurrencies = computed(() =>
  priceFields.filter(f => catalog.items.some(i => i[f] != null)).map(f => f.replace('MSRP', ''))
)
const currency = computed(() => settings.currency)
const currencyDropdownItems = computed(() =>
  availableCurrencies.value.map(cur => ({
    label: cur,
    onSelect: () => settings.setCurrency(cur)
  }))
)
</script>
